import { TableV2 } from '@anytag/shared-atoms';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { FacebookPageAnalyticsPostsPayload } from '@anytag/graphql';
import { InfluencerFacebookAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsFacebookPostsListTable } from './hooks';

export interface AnalyticsFacebookPostsListProps extends TableData<FacebookPageAnalyticsPostsPayload> {
  mainSocialAccountId?: number;
}

export const AnalyticsFacebookPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: AnalyticsFacebookPostsListProps) => {
  const { columns } = useAnalyticsFacebookPostsListTable();

  return (
    <>
      <TableV2 loading={loading} rowHeight="62px" columns={columns} data={data} noTopBorderRadius hasBorder />

      <InfluencerFacebookAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
        isAnalytics
      />
    </>
  );
};
